import { TSpecOfferSetPhoneRequest } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/set-phone/dto/requestDto';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

export const formatPhone = ([, ...rest]: string) => ['8', ...rest].join('');

/**
 * Добавление номера телефона к договору для подписок (IVI, Кинопоиск и тд) в биллинге
 * @link https://master.spec-offer.sandbox.d2c.r-one.io/docs#/Специальные%20предложения/SpecOfferController_setPhone
 */
export const setPhone = (providerId: number, payload: TSpecOfferSetPhoneRequest): IRequest => ({
    uri: `/api/v1/${providerId}/set-phone`,
    method: 'POST',
    withAuth: true,
    withProvider: true,
    body: JSON.stringify(payload),
});
